///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'winde-date-format',
    template: `{{ outputDate }}`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthDateFormatComponent implements OnInit {
    public outputDate: string;
    @Input() showTimeAgo = false;
    @Input() showHours = false;
    private dateObject: Date;

    constructor(private readonly datePipe: DatePipe) {}

    @Input() set date(value: Date | string) {
        if (typeof value === 'string') {
            this.dateObject = new Date(value);
        }
        this.setDateOutput(this.dateObject);
    }

    ngOnInit(): void {
        this.setDateOutput(this.dateObject);
    }

    private setDateOutput(date: Date) {
        if (!date) {
            this.outputDate = 'not yet';
            return;
        }

        let dateFormat = 'M.d.y';

        if (this.showHours) {
            dateFormat += ' h:mm a';
        }

        this.outputDate = this.datePipe.transform(date, dateFormat);

        if (this.showTimeAgo) {
            this.outputDate += ` (${this.getDaysAgo(date)})`;
        }
    }

    private getDaysAgo(date: Date) {
        const timeToDaysConst = 1000 * 60 * 60 * 24;
        const now = new Date();

        if (now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth() && now.getDate() === date.getDate()) {
            return 'Today';
        } else {
            const timeDelta = (now.getTime() - date.getTime()) / timeToDaysConst;
            const daysDelta = Math.floor(timeDelta);

            if (daysDelta <= 1) {
                return 'Yesterday';
            } else if (daysDelta < 7) {
                return `${daysDelta} days ago`;
            } else if (daysDelta < 30) {
                return `${Math.floor(daysDelta / 7)} week${daysDelta / 7 >= 2 ? 's' : ''} ago`;
            } else if (daysDelta < 365) {
                return `${Math.floor(daysDelta / 30)} month ago`;
            } else {
                return `${Math.floor(daysDelta / 365)} year${daysDelta / 365 >= 2 ? 's' : ''} ago`;
            }
        }
    }
}
